module.exports = __webpack_public_path__ + "static/img/mobile_banner.fac10ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img/mobile_banner.png
// module id = fr+C
// module chunks = 1